import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';

export const AgreementText = styled(Typography).attrs({
  variant: 'body5'
})`
  width: 100%;
  text-align: center;
  text-align-last: center;
  color: var(--textAndLabels-tertiary);
  hyphens: auto;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding: 0 0 15px 0;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: 16px;
  }
`;

export const AgreementLink = styled(Typography).attrs({
  variant: 'body5'
})`
  display: inline-block;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  color: inherit;
  cursor: pointer;
`;
